import { createSignal, Show } from "solid-js";
import { useDropdownGroup } from "~/_context/Dropdown";

import "~/_assets/transitions.css";

export const Dropdown = (props) => {
	const group = useDropdownGroup(); // may be undefined if used standalone
	const id = props.id ?? "notu";

	const isOpen = () => (group ? group.activeId() === id : (props.isOpen ?? false));

	const toggle = () => {
		if (group) group.toggle(id);
		else props.onToggle?.();
	};

	const [hover, setHover] = createSignal(false);
	const [selectedLabel, setSelectedLabel] = createSignal(
		props.list?.find((item) => item.value === props.value)?.label ?? "Select",
	);

	const handleSelect = (item) => {
		setSelectedLabel(item.label);
		props.onSelect?.(item.value);
		group.setActiveId(null);
	};

	return (
		<div
			class={`relative inline-block text-left dropdown ${props.class ?? ""}`}
			onMouseEnter={() => setHover(true)}
			onMouseLeave={() => setHover(false)}>
			<button
				type="button"
				onClick={toggle}
				class={`inline-flex items-center justify-between min-w-50 gap-x-1 rounded-md ${props.bgColour ?? "bg-white"} ${props.txtColour ?? "text-gray-900"} px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-gray-300 hover:opacity-60`}>
				<span class="block w-[12rem] truncate overflow-hidden text-ellipsis whitespace-nowrap">
					{selectedLabel()}
				</span>

				<div
					class="overflow-hidden "
					classList={{
						"opacity-0": !hover() && !isOpen(),
						"opacity-100 ": hover() || isOpen(),
					}}>
					<svg
						viewBox="0 0 20 20"
						fill="currentColor"
						aria-hidden="true"
						class="size-5 text-gray-400 transition-transform duration-150"
						classList={{ "rotate-180": isOpen() }}>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
						/>
					</svg>
				</div>
			</button>

			{/* ✅ List only in DOM while open */}
			<Show when={isOpen()}>
				<div class="dropdown absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5">
					<div class="py-1">
						{Array.isArray(props.list) &&
							props.list.map((item) => (
								<button
									type="button"
									onClick={[handleSelect, item]}
									class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-hidden">
									{item.label}
								</button>
							))}
					</div>
				</div>
			</Show>
		</div>
	);
};
